// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICovTableDto
 */
export interface ICovTableDto {
    /**
     * 
     * @type {number}
     * @memberof ICovTableDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICovTableDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICovTableDto
     */
    identifier?: string;
}

/**
 * Check if a given object implements the ICovTableDto interface.
 */
export function instanceOfICovTableDto(value: object): value is ICovTableDto {
    return true;
}

export function ICovTableDtoFromJSON(json: any): ICovTableDto {
    return ICovTableDtoFromJSONTyped(json, false);
}

export function ICovTableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICovTableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
    };
}

export function ICovTableDtoToJSON(json: any): ICovTableDto {
    return ICovTableDtoToJSONTyped(json, false);
}

export function ICovTableDtoToJSONTyped(value?: ICovTableDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'identifier': value['identifier'],
    };
}

